import { render, staticRenderFns } from "./PersonnalInformation.vue?vue&type=template&id=2c81608a&scoped=true&"
import script from "./PersonnalInformation.vue?vue&type=script&lang=js&"
export * from "./PersonnalInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonnalInformation.vue?vue&type=style&index=0&id=2c81608a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81608a",
  null
  
)

export default component.exports